exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".statistic-wrapper {\n    padding: 4px;\n    margin: 4px;\n    text-align: right;\n    vertical-align: middle;\n    height: 30px;\n    display: inline-block;\n}\n\n.statistic-data {\n    font-size: 16px;\n    font-weight: 600;\n    font-family: Metropolis, \"Avenir Next\", \"Helvetica Neue\", Arial, sans-serif;\n    line-height: 16px;\n}\n\n.statistic-text {\n    font-size: 10px;\n    line-height: 10px;\n    text-transform: uppercase;\n    font-family: Metropolis, \"Avenir Next\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.statistic-column-block {\n    display: inline-block;\n    text-align: right;\n}\n\n.statistic-column-title {\n    position: relative;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-family: Metropolis, \"Avenir Next\", \"Helvetica Neue\", Arial, sans-serif;\n}\n\n.statistic-column-title-pro {\n    top: -10px;\n}\n\n.statistic-column-title-repo {\n    top: 3px;\n}\n\n.statistic-item-divider {\n    height: 54px;\n    display: inline-block;\n    width: 1px;\n    background-color: #ccc;\n    opacity: 0.55;\n    margin-left: 4px;\n    margin-right: 12px;\n    position: relative;\n    top: 3px;\n}\n\n.statistic-block {\n    display: inline-block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/statictics/statistics.component.css
// module id = 464
// module chunks = 0